module.exports = __webpack_public_path__ + "img/loader.f2c115d7.gif";